import { getVersion } from '@foundation-player/core';

export function determineVersion(version?: string): [string, boolean] {
  const match = /foundationVersion=(\d+.\d+.\d+(-[a-z]+\.\d+)?)/.exec(location.href);
  if (match) {
    // eslint-disable-next-line no-console
    console.warn('Overwrite foundation player version', match[1]);
    return [match[1], true];
  }

  return [version ?? getVersion(), false];
}
